enum RendersActionTypes {
  LOAD_RENDERS_LIST = 'renders/getRendersList',
  LOAD_RENDERS_LIST_FULFILLED = 'renders/getRendersListFulfilled',
  LOAD_RENDERS_LIST_REJECTED = 'renders/getRendersListRejected',
}

export default RendersActionTypes;
